/**
 * 突破率の評価確定に必要な日数。初回課金から N 回目の与信（AUTH）到達までの日数 + 14日。
 * 14日は「与信から売上確定（CAPTURE）まで」の上限で、`PAYMENT_CYCLE_DAYS = 14`
 * （air-closet-mens の settlement-auth.service.ts）に対応する。本番実測
 * （2026-09-11 時点 / 2026-05-28 以降のコホート）でも 2〜4回目すべて 100% が 14日以内に確定していた。
 *
 * 加算する AUTH 到達日数は **30日刻みではなく実測値**を使う。月の長さの差が回を追うごとに
 * 積み上がるため、実測は 30日 / 61日 / 92日 になる:
 *
 * | 回 | AUTH 到達（最短） | + 14日 | 確定判定日数 |
 * |---|---|---|---|
 * | 2回目（1ヶ月目突破） | 30日 | 44 | m1 |
 * | 3回目（2ヶ月目突破） | 61日 | 75 | m2 |
 * | 4回目（3ヶ月目突破） | 92日 | 106 | m3 |
 *
 * 30日刻みで 74 / 104 と置くと、その日にはまだ 1 件も売上確定しておらず、未確定
 * （`paid_status` 4/5 = 成功側に数えられる）を確定値として表示してしまう。
 *
 * API とフロントの両方が参照するためこのパッケージが唯一の定義元。
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business 1〜3ヶ月目突破率コホートの確定判定に使う評価日数を一元管理する
 * @graph-connects none
 */
export const BREAKTHROUGH_EVALUATION_DAYS = {
    m1: 44,
    m2: 75,
    m3: 106,
};
//# sourceMappingURL=breakthrough.js.map